import type { EvmAddress } from 'sushi/evm'
import type { KatanaTokenListEntry } from './katana-token-list'

// Resolves a token's metadata from the Katana API's V3 token route when it
// isn't present in the curated token list. Returns `null` when the token is
// unknown to the indexer or the API is unreachable.
const KATANA_API_URL =
  process.env['NEXT_PUBLIC_KATANA_API_URL']?.replace(/\/+$/, '') ||
  'https://api.katana.network'

interface ApiTokenResponse {
  success: boolean
  data: {
    address: string
    name: string
    symbol: string
    decimals: number
  } | null
}

export async function searchSubgraphToken(
  address: EvmAddress,
): Promise<KatanaTokenListEntry | null> {
  try {
    const response = await fetch(
      `${KATANA_API_URL}/v1/dex-v3/tokens/${address.toLowerCase()}`,
      { headers: { Accept: 'application/json' } },
    )

    if (!response.ok) return null

    const result: ApiTokenResponse = await response.json()

    if (result.success && result.data) {
      return {
        address: result.data.address,
        name: result.data.name,
        symbol: result.data.symbol,
        decimals: result.data.decimals,
        approved: false,
      }
    }
  } catch {
    // API unavailable
  }

  return null
}
